import moment from 'moment-timezone'

export default ({ timestamp }) =>
  moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
